import { CheckboxInput } from '@framework/form/inputs/CheckboxInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { RuleType } from '../../IRule.ts';
import { type IRuleConfigComponentProps } from '../../IRuleType.ts';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage.tsx';

const FIELD_NAME = `rules.${RuleType.Required}.value`;
const FIELD_CUSTOM_MESSAGE = `rules.${RuleType.Required}.customMessage`;

export function RequiredRuleComponent(props: IRuleConfigComponentProps) {
  // const {  } = props;

  return (
    <FormItem
      name={FIELD_NAME}
      label={null}
      layout={{ removeLabelSpace: true }}
    >
      <CheckboxInput name={FIELD_NAME} defaultChecked={false}>
        Campo obbligatorio
      </CheckboxInput>
      <CustomValidationRuleMessage isGhostType name={FIELD_CUSTOM_MESSAGE} />
    </FormItem>
  );
}
